/**
 * @desc 导出装箱明细
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.transportMaster.exportTrackPackingDetailsReport.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/exportTrackPackingDetailsReport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
